/**
 * Phase AA4-FIX — sanitize Acharya AI payload before render.
 */

export const ACHARYA_INVALID_RESPONSE =
  "Āchārya could not understand the response. Please try again.";

function cleanText(value) {
  if (value == null || value === "null" || value === "undefined") return "";
  return typeof value === "string" ? value : "";
}

export function sanitizeAcharyaAnswer(answer) {
  if (typeof answer === "string") {
    return {
      answer,
      reflection: "",
      teaching: "",
      story: "",
      steps: [],
      closing: "",
      error: null,
      story_cards: [],
      tattva_highlights: [],
      sadhana_recommendation: "",
      dharma_principles: [],
      shastra_grounding: { sources_used: [], explanation: "" },
      personalized_guidance: "",
      response_mode: "flow",
    };
  }
  if (!answer || typeof answer !== "object") {
    return {
      reflection: "",
      teaching: "",
      story: "",
      steps: [],
      closing: "",
      answer: "",
      error: null,
      response_mode: "structured",
    };
  }

  const stepsRaw = answer.steps;
  const steps = Array.isArray(stepsRaw)
    ? stepsRaw.filter((s) => typeof s === "string")
    : [];

  const meta = answer.meta && typeof answer.meta === "object" ? answer.meta : null;

  return {
    reflection: cleanText(answer.reflection),
    teaching: cleanText(answer.teaching),
    story: cleanText(answer.story),
    steps,
    closing: cleanText(answer.closing),
    answer: cleanText(answer.answer),
    error: answer.error ?? null,
    story_cards: Array.isArray(answer.story_cards) ? answer.story_cards : [],
    tattva_highlights: Array.isArray(answer.tattva_highlights) ? answer.tattva_highlights : [],
    sadhana_recommendation:
      typeof answer.sadhana_recommendation === "string" ? answer.sadhana_recommendation : "",
    dharma_principles: Array.isArray(answer.dharma_principles) ? answer.dharma_principles : [],
    shastra_grounding:
      answer.shastra_grounding && typeof answer.shastra_grounding === "object"
        ? answer.shastra_grounding
        : { sources_used: [], explanation: "" },
    personalized_guidance:
      typeof answer.personalized_guidance === "string" ? answer.personalized_guidance : "",
    response_mode:
      typeof answer.response_mode === "string" ? answer.response_mode : "structured",
    meta,
    isUnavailable: meta?.source === "unavailable",
  };
}

export function hasAcharyaBody(safe) {
  return Boolean(
    safe.reflection?.trim() ||
      safe.teaching?.trim() ||
      safe.story?.trim() ||
      safe.steps?.length ||
      safe.closing?.trim() ||
      safe.answer?.trim()
  );
}

/** True when structured JSON sections should render (avoid duplicating full answer in bubble). */
export function hasStructuredSections(safe) {
  return Boolean(
    safe?.reflection?.trim() ||
      safe?.teaching?.trim() ||
      safe?.story?.trim() ||
      safe?.steps?.length ||
      safe?.closing?.trim()
  );
}

export function formatDisplayAnswer(safe) {
  if (!safe) return "";
  if (hasStructuredSections(safe)) {
    return safe.reflection?.trim() || "";
  }
  return safe.answer?.trim() || safe.teaching?.trim() || "";
}
